import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import CabinetCard from './CabinetCard';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

CabinetList.propTypes = {
    products: PropTypes.array.isRequired,
};

export default function CabinetList({ idPermission, getData, products, functDelete, setData, functEdit, screenPermissions, ...other }) {
    const navigate = useNavigate();
    return (
        <Grid container spacing={3} {...other}>
            {products.map((product) => (
                <Grid key={product.id} item xs={12} sm={6} md={3}>
                    <CabinetCard
                        navigate={() =>
                            product.block_status === '1'
                                ? navigate(`/home/manager-cabinet/${idPermission}/drawer/${product.id}`)
                                : false
                        }
                        idPermission={idPermission}
                        getData={getData}
                        functDelete={functDelete}
                        functEdit={functEdit}
                        product={product}
                        setData={setData}
                        screenPermissions={screenPermissions}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
